import React, { createContext, useCallback, useContext } from "react";
import EditorModal from "../dashboard/EditorModal";
import { useEditor } from "../../hooks/useEditor";
import { useTheme } from "../../context/ThemeContext";

const LandingPreviewEditorContext = createContext(null);

export function LandingPreviewEditorProvider({ children }) {
  const { darkMode } = useTheme();
  const {
    isOpen,
    title,
    content,
    openEditor,
    closeEditor,
  } = useEditor();

  const openPreviewEditor = useCallback(
    (editorTitle, value) => {
      openEditor("preview", editorTitle, value);
    },
    [openEditor],
  );

  const handleSave = useCallback(() => {
    closeEditor();
  }, [closeEditor]);

  return (
    <LandingPreviewEditorContext.Provider value={{ openPreviewEditor }}>
      {children}
      <EditorModal
        isOpen={isOpen}
        title={title}
        content={content}
        onClose={closeEditor}
        onSave={handleSave}
        darkMode={darkMode}
      />
    </LandingPreviewEditorContext.Provider>
  );
}

export function useLandingPreviewEditor() {
  const ctx = useContext(LandingPreviewEditorContext);
  if (!ctx) {
    throw new Error(
      "useLandingPreviewEditor must be used within LandingPreviewEditorProvider",
    );
  }
  return ctx;
}
